<div class="d-flex justify-content-center m">
  <div class="card">
    <div class="card-header text-center">
      <h4 class="display-5">Send Email To Students</h4>
    </div>
    <form #uploadform="ngForm" name="uploadform" class="ml-5 mr-5 mt-1">
      <div class="row mb-3">
        <div class="col-md-6">
          <label class="sbw_light">Mail Subject: *</label>
          <input class="form-control" type="text" placeholder="Subject" aria-label="Subject" [(ngModel)]="mailSubject"
            [ngModelOptions]="{standalone: true}">
        </div>

        <div class="col-md-6">
          <label class="sbw_light">Course: </label>
          <span class="position-relative d-inline-flex align-items-center">
            <button type="button" data-toggle="dropdown" aria-expanded="false" title="Course"
              class="d-flex align-items-center px-2 bg-transparent border-0 text-body"><i
                class="fa fa-info-circle"></i></button>
            <span class="info-popup dropdown-menu p-2">
              <span class="form-info-p">Who the email goes to. All Students reaches everyone enrolled at the school. Pick a course and only the students on that course get it.</span>
            </span>
          </span>
          <select class="form-select form-control" [(ngModel)]="selectedId" [ngModelOptions]="{standalone: true}"
            (change)="onModuleSelected($event.target.value)" required [disabled]="isreadonly">
            <option selected disabled>Select Course</option>
            <option value="0">All Students</option>
            <option *ngFor="let module of modules" [value]="module.id">{{module.moduleName}}</option>
          </select>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6" *ngIf="selectedCode">
          <label class="sbw_light">Code:</label>
          <span class="position-relative d-inline-flex align-items-center">
            <button type="button" data-toggle="dropdown" aria-expanded="false" title="Code"
              class="d-flex align-items-center px-2 bg-transparent border-0 text-body"><i
                class="fa fa-info-circle"></i></button>
            <span class="info-popup dropdown-menu p-2">
              <span class="form-info-p">The course code, filled in from the course you picked. Change it on the course itself.</span>
            </span>
          </span>
          <input class="form-control" type="text" readonly [(ngModel)]="selectedCode"
            [ngModelOptions]="{standalone: true}">
        </div>
      </div>
      <div>
        <p class="text-muted fs-6 fw-lighter"><small>Placeholders: {{placeholder}}</small></p>
      </div>
      <quill-editor placeholder="Enter Message Body" classes="ql-container--lg" required [(ngModel)]="mailBody"
        [ngModelOptions]="{standalone: true}"></quill-editor>
      <div class="card-footer">
        <div class="d-flex flex-column flex-md-row justify-content-around">
          <button type="submit" class="btn btn--warning m-1" (click)="testMail()"
            title="Sends this email to your own address so you can check how it looks"
            [disabled]="disableButtons">Test</button>
          <button type="submit" class="btn m-1" [disabled]="disableButtons"
            title="Keeps this subject and body so you can reuse it later"
            (click)="saveMailDraft()">Save Email Template</button>
          <button type="submit" class="btn m-1" [disabled]="disableButtons"
            title="Sends the email to everyone in the Course selection above. It cannot be recalled"
            (click)="sendMail()">Send</button>
        </div>
      </div>
    </form>
    <!-- templates -->
    <div *ngIf="drafts?.length > 0">
      <h4 class="display-5 text-center">Previous Mail Templates</h4>
      <div class="row m-0 mb-5">
        <div class="col-12 col-md-4 card text-center fs-5 border"
          *ngFor="let draft of drafts"
          (click)="setDraftAsMailBody(draft)"
          style="cursor: pointer;"
        >
          <div class="d-flex justify-content-center align-items-center">
            <span class="card-body">{{draft.subject}}</span>
            <i *ngIf="draft.id" 
                (click)="deleteMailDraft(draft.id)"
                class="fa fa-trash text-danger border p-3"></i>   
          </div>
        </div>
      </div>      
    </div>
  </div>
</div>
